/*
* @描述: layout布局容器
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2022-11-23 17:40:41
*/
<template>
    <div class="page_wrapper" v-loading="loading">
        <div class="main_wrapper main_container_ver">
            <el-aside width="220px">
                <div class="logo_wrap">
                    <img width="35" class="logo_img" src="https://www.enlightv.com/Public/Admin/img/ljylogo.png" alt="">
                    <h2 v-text="'澜精灵SaaS'"></h2>
                </div>
                <Menu/>
            </el-aside>

            <el-main>
                <el-header height="68px">
                    <Header></Header>
                </el-header>
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="$route.meta.parentRoute"
                                        :to="{ path: $route.meta.parentRoute.path }"
                                        v-text="$route.meta.parentRoute.name">
                    </el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: $route.path }" v-if="$route.meta.name">
                        <i :class="$route.meta.icon"></i>
                        <span v-text="$route.meta.name"></span>
                    </el-breadcrumb-item>
                </el-breadcrumb>
                <div class="router_wrap">
                    <router-view/>
                </div>
            </el-main>
        </div>
    </div>
</template>
<script>
    import Header from './components/Header'
    import Menu from './components/Menu'

    export default {
        name: 'layout',
        data() {
            return {
                loading: false,
            }
        },
        mounted() {

        },
        methods: {},
        components: {
            Header,
            Menu,
        },
    }
</script>
<style lang="scss" scoped>
  .page_wrapper {
    width: 100%;
    height: 100%;

    .el-header {
      padding: 0;
    }

    .main_wrapper {

      .el-aside {
        position: relative;

        .logo_wrap {
          width: 220px;
          height: 68px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-bottom: 1px solid #e7eaec;

          .logo_img {
            margin-right: 10px;
          }
        }
      }
    }

    .main_container_ver {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex: 1;
      flex-basis: auto;
      box-sizing: border-box;
      height: 100%;
    }

    .main_container_hor {
      width: 100%;
      height: calc(100vh - 121px);
    }

    .el-breadcrumb {
      background-color: #ffffff;
      padding: 0 16px;
      line-height: 40px;

      .el-breadcrumb__inner {
        line-height: 22px !important;

        i {
          margin-right: 5px;
          text-align: center;
          font-size: 16px;
          vertical-align: middle;
          display: inline-block;
        }

        span {
          color: #333333;
          font-weight: 500;
        }
      }
    }

    .el-main {
      min-width: 400px;
      height: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      background-color: #f3f3f4;
      padding: 0;

      .router_wrap {
        width: 100%;
        height: calc(100% - 94px);
        padding: 16px;
        flex: 1;
        overflow-y: hidden;
      }
    }
  }

</style>
